/* Blessed Choice ATACADO — calculadora de frete (v1.0, porte do bc-frete.js v1.5.3 do varejo).
 * Mesmo Worker e mesmo payload do varejo: POST {zipcode, items:[{variant_id, product_id, sku, price, weight, quantity}]}.
 * Dois modos no mesmo elemento <bc-frete>:
 *   data-modo="produto"  → cota SACOLA (/cart.js) + o que está escolhido na grade de tamanhos (<bc-grade>, várias
 *                          variantes de uma vez). Sem grade (kits, oversized) usa o formulário do tema ([name="id"] + [name="quantity"]).
 *   data-modo="carrinho" → cota só a sacola (página do carrinho e gaveta).
 * Recalcula sozinho quando a grade muda (bc:grade-alterada, ou input/clique dentro da grade) e quando a sacola muda
 * (cart:updated / cart:refresh do tema, bc:cart-changed). A gaveta é re-renderizada pelo tema a cada alteração:
 * o resultado fica num cache em memória por CEP+itens, então o elemento novo pinta na hora sem chamar o Worker de novo.
 * Sem frete grátis aqui de propósito: a regra do atacado (cupom BC100 na Yampi) não é aplicada pelo Worker.
 */
(function () {
  'use strict';
  if (window.customElements.get('bc-frete')) return;

  var STORAGE_KEY = 'bc_frete_cep';
  var CACHE = {}; // chave CEP|itens → { quotes, uf, blocked } (só respostas boas)
  var BRL = function (v) { return 'R$ ' + Number(v).toFixed(2).replace('.', ','); };
  var maskCep = function (v) { v = String(v || '').replace(/\D/g, '').slice(0, 8); return v.length > 5 ? v.slice(0, 5) + '-' + v.slice(5) : v; };
  var read = function (k) { try { return localStorage.getItem(k); } catch (e) { return null; } };
  var save = function (k, v) { try { localStorage.setItem(k, v); } catch (e) {} };
  var pecas = function (n) { return n + (n === 1 ? ' peça' : ' peças'); };

  /** Preço por peça do progressivo (centavos), com a mesma configuração do bc-atacado.js. Só serve de valor declarado. */
  function precoFaixa(totalPecas, precoVariante) {
    var cfg = window.BCAtacadoConfig || {};
    var faixas = (cfg.faixas || []).slice().sort(function (a, b) { return a.qtd - b.qtd; });
    var p = precoVariante;
    faixas.forEach(function (f) { if (totalPecas >= f.qtd) p = Math.min(p, f.preco); });
    return p;
  }

  class BcFrete extends HTMLElement {
    connectedCallback() {
      if (this._pronto) return;
      this._pronto = true;
      this.endpoint = this.dataset.endpoint;
      this.modo = this.dataset.modo === 'carrinho' ? 'carrinho' : 'produto';
      this.showAll = this.dataset.showAll === 'true';
      this.productId = this.dataset.productId || '';
      this.variants = [];
      try { this.variants = JSON.parse((this.querySelector('[data-bc-variants]') || {}).textContent || '[]'); } catch (e) {}

      this.form = this.closest('form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');
      this.input = this.querySelector('[data-bc-cep]');
      this.btn = this.querySelector('[data-bc-calc]');
      this.out = this.querySelector('[data-bc-result]');
      this.lastKey = null;

      var self = this;
      this.input.addEventListener('input', function (e) { e.target.value = maskCep(e.target.value); });
      this.input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); self.quote(); } });
      this.btn.addEventListener('click', function (e) { e.preventDefault(); self.quote(); });

      var timer;
      this._recota = function () {
        clearTimeout(timer);
        timer = setTimeout(function () { if (self.isConnected && self.input.value.length === 9) self.quote(true); }, 450);
      };
      // grade mudou: evento do DevTema e, por garantia, digitação e cliques (+/−) dentro de qualquer <bc-grade> da página
      this._naGrade = function (e) { if (e.target && e.target.closest && e.target.closest('bc-grade')) self._recota(); };
      this._ouvir = [
        [document, 'bc:grade-alterada', this._recota],
        [document, 'input', this._naGrade],
        [document, 'click', this._naGrade],
        [document, 'cart:updated', this._recota],
        [document, 'cart:refresh', this._recota],
        [document, 'bc:cart-changed', this._recota]
      ];
      if (this.modo === 'produto') {
        // produto sem grade: troca de variante (select/swatch) ou quantidade do tema
        this._noForm = function (e) { if (self.form && self.form.contains(e.target) && !self.contains(e.target)) self._recota(); };
        this._ouvir.push([document, 'change', this._noForm], [window, 'popstate', this._recota]);
      }
      this._ouvir.forEach(function (o) { o[0].addEventListener(o[1], o[2]); });

      var stored = read(STORAGE_KEY);
      if (stored && stored.length === 9) { this.input.value = stored; this.quote(true); }
    }

    disconnectedCallback() {
      if (this._ouvir) this._ouvir.forEach(function (o) { o[0].removeEventListener(o[1], o[2]); });
      this._pronto = false;
    }

    variante(id) {
      for (var i = 0; i < this.variants.length; i++) if (String(this.variants[i].id) === String(id)) return this.variants[i];
      return null;
    }

    /** Grade de tamanhos deste produto (não a da janela de compra rápida). */
    grade() {
      var g = document.querySelector('bc-grade[data-produto="' + this.productId + '"]:not([data-bc-rapida])');
      return g || null;
    }

    /** O que está escolhido agora na página: [{variant_id, quantity, preco(centavos), weight}] */
    escolhidos() {
      var self = this, g = this.grade();
      if (g) {
        var lista = typeof g.itens === 'function' ? g.itens() : Array.prototype.map.call(g.querySelectorAll('[data-bc-linha]'), function (l) {
          return { id: l.getAttribute('data-variante'), quantity: parseInt((l.querySelector('[data-bc-qtd]') || {}).value, 10) || 0, preco: parseInt(l.getAttribute('data-preco'), 10) || 0 };
        }).filter(function (i) { return i.quantity > 0; });
        return { grade: true, itens: lista.map(function (i) {
          var v = self.variante(i.id) || {};
          return { variant_id: Number(i.id), quantity: i.quantity, preco: i.preco || Math.round((v.price || 0) * 100), weight: v.weight || 0, sku: v.sku || '' };
        }) };
      }
      // sem grade: formulário do tema
      var id = null;
      if (this.form) {
        var el = this.form.querySelector('[name="id"]:checked') || this.form.querySelector('[name="id"]');
        if (el && el.value) id = el.value;
      }
      var urlId = new URL(location.href).searchParams.get('variant');
      if (urlId) id = urlId;
      var v = this.variante(id) || this.variants[0];
      if (!v) return { grade: false, itens: [] };
      var q = (this.form && this.form.querySelector('[name="quantity"]')) || document.querySelector('[name="quantity"]');
      var n = q ? parseInt(q.value, 10) : 1;
      return { grade: false, itens: [{ variant_id: v.id, quantity: n > 0 ? n : 1, preco: Math.round(v.price * 100), weight: v.weight || 0, sku: v.sku || '' }] };
    }

    setState(html, cls) {
      this.out.className = 'bc-frete__result' + (cls ? ' bc-frete__result--' + cls : '');
      this.out.innerHTML = html;
      this.out.dataset.ok = cls === 'ok' ? '1' : '';
    }

    quote(silent) {
      var cep = this.input.value;
      if (cep.length !== 9) { if (!silent) { this.setState(this.esc(this.msg('invalid')), 'error'); this.input.focus(); } return; }
      var self = this;
      save(STORAGE_KEY, cep);

      this.getCart().then(function (cart) {
        var cartQty = cart.reduce(function (n, it) { return n + it.quantity; }, 0);
        var items = cart.map(function (it) { return Object.assign({}, it); });
        var sel = self.modo === 'produto' ? self.escolhidos() : { grade: false, itens: [] };
        var selQty = sel.itens.reduce(function (n, it) { return n + it.quantity; }, 0);
        var total = cartQty + selQty;
        sel.itens.forEach(function (s) {
          var price = precoFaixa(total, s.preco) / 100;
          var found = false;
          // variante que já está na sacola: soma a quantidade e, se a soma mudou a faixa, usa o preço da faixa nova
          for (var i = 0; i < items.length; i++) if (String(items[i].variant_id) === String(s.variant_id)) { items[i].quantity += s.quantity; items[i].price = Math.min(items[i].price, price); found = true; }
          if (!found) items.push({ variant_id: s.variant_id, product_id: Number(self.productId) || self.productId, sku: s.sku, price: price, weight: s.weight, quantity: s.quantity });
        });

        if (!items.length) {
          self.lastKey = null;
          self.setState(self.esc(self.msg(self.modo === 'produto' ? 'empty' : 'emptyCart')), 'info');
          return;
        }
        var key = cep + '|' + items.map(function (it) { return it.variant_id + 'x' + it.quantity; }).sort().join(',');
        if (key === self.lastKey && self.out.dataset.ok === '1') return; // nada mudou
        self.lastKey = key;
        var ctx = { qty: selQty, cartQty: cartQty };

        if (CACHE[key]) { self.show(CACHE[key], cep, ctx); return; }

        self.btn.disabled = true;
        self.setState('<span class="bc-frete__spinner" aria-hidden="true"></span> ' + self.esc(self.msg('loading')), 'loading');
        var ctrl = typeof AbortController !== 'undefined' ? new AbortController() : null;
        var t = setTimeout(function () { if (ctrl) ctrl.abort(); }, 12000);
        return fetch(self.endpoint, {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ zipcode: cep, items: items }),
          signal: ctrl ? ctrl.signal : undefined
        }).then(function (r) {
          if (r.status === 400) return { _cep: true };
          if (!r.ok) throw new Error('HTTP ' + r.status); // 403 (origem não liberada), 5xx etc.
          return r.json();
        }).then(function (j) {
          if (self.lastKey !== key) return; // resposta antiga
          if (j._cep) { self.setState(self.esc(self.msg('notfound')), 'error'); return; }
          if (!j.ok) throw new Error('ok=false');
          if (!j.blocked && (!j.quotes || !j.quotes.length)) throw new Error('sem cotações');
          CACHE[key] = j;
          self.show(j, cep, ctx);
        }).finally(function () { clearTimeout(t); });
      }).catch(function () {
        self.lastKey = null;
        self.setState(self.esc(self.msg('error')), 'error');
      }).finally(function () { self.btn.disabled = false; });
    }

    show(j, cep, ctx) {
      if (j.blocked) {
        this.setState(this.esc(this.msg('blocked')), 'blocked');
        document.dispatchEvent(new CustomEvent('bc:frete-quoted', { detail: { cep: cep, blocked: true, uf: j.uf } }));
        return;
      }
      var quotes = j.quotes.map(function (q) { return Object.assign({}, q); });
      this.render(quotes, ctx.qty, ctx.cartQty);
      document.dispatchEvent(new CustomEvent('bc:frete-quoted', { detail: { cep: cep, uf: j.uf, cheapest: quotes[0].price, modo: this.modo } }));
      if (window.dataLayer) window.dataLayer.push({ event: 'bc_frete_calculado', loja: 'atacado', modo: this.modo, cep: cep, uf: j.uf, quantity: ctx.qty, cart_quantity: ctx.cartQty, cheapest: quotes[0].price });
    }

    /** Itens da sacola (/cart.js) no formato do Worker. Falha → sacola vazia. */
    getCart() {
      return fetch('/cart.js', { cache: 'no-store', credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) { return r.ok ? r.json() : { items: [] }; })
        .then(function (c) {
          return (c.items || []).map(function (it) {
            return { variant_id: it.variant_id, product_id: it.product_id, sku: it.sku || '', price: (it.final_price || it.price) / 100, weight: (it.grams || 0) / 1000, quantity: it.quantity };
          });
        }).catch(function () { return []; });
    }

    render(quotes, qty, cartQty) {
      var self = this;
      var cheapest = quotes[0];
      var fastest = quotes.slice().sort(function (a, b) { return a.days - b.days || a.price - b.price; })[0];
      var list = this.showAll ? quotes : quotes.filter(function (q) { return q === cheapest || q === fastest; });
      var rows = list.map(function (q) {
        var tag = q === cheapest ? '<em class="bc-frete__tag">' + self.esc(self.msg('cheapest')) + '</em>'
          : (q === fastest ? '<em class="bc-frete__tag bc-frete__tag--fast">' + self.esc(self.msg('fastest')) + '</em>' : '');
        return '<li class="bc-frete__row' + (q === cheapest ? ' bc-frete__row--best' : '') + '">' +
          '<span class="bc-frete__name"><span>' + self.esc(q.name) + tag + '</span>' +
          '<small>' + self.esc(self.msg('days').replace('{days}', q.days).replace(Number(q.days) === 1 ? 'dias úteis' : '\u0000', 'dia útil')) + '</small></span>' +
          '<strong class="bc-frete__price">' + BRL(q.price) + '</strong></li>';
      }).join('');
      var note;
      if (qty === 0) note = this.msg('noteOnlyCart').replace('{total}', pecas(cartQty));
      else if (cartQty > 0) note = this.msg('noteCart').replace('{total}', pecas(qty + cartQty)).replace('{cart}', cartQty).replace('{qty}', qty);
      else note = this.msg('note').replace('{qty}', pecas(qty));
      if (qty === 1) note = note.replace('escolhidas', 'escolhida'); // «1 peça escolhida»
      this.setState('<ul class="bc-frete__list">' + rows + '</ul>' + (note ? '<p class="bc-frete__note">' + this.esc(note) + '</p>' : ''), 'ok');
    }

    msg(k) { return this.dataset['msg' + k.charAt(0).toUpperCase() + k.slice(1)] || ''; }
    esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  }
  window.customElements.define('bc-frete', BcFrete);
})();
